<script setup lang="ts">
import type { TabsListProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { TabsList } from "reka-ui"
import { cn } from "@/lib/utils"

const props = withDefaults(defineProps<TabsListProps & {
  class?: HTMLAttributes["class"]
  variant?: "default" | "line"
}>(), { variant: "default" })

const delegatedProps = reactiveOmit(props, "class", "variant")
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    :data-variant="variant"
    v-bind="delegatedProps"
    :class="cn(
      'text-muted-foreground inline-flex h-8 w-fit max-w-full items-center justify-center gap-0.5 rounded-lg bg-muted/60 p-0.5',
      variant === 'line' && 'h-10 w-full justify-start gap-4 rounded-none border-b border-border bg-transparent p-0',
      props.class,
    )"
  >
    <slot />
  </TabsList>
</template>

<style scoped>
/* Один вариант для вкладок карточек и диалогов: активная линия остаётся
   видна в любой цветовой схеме, а клавиатурой по-прежнему управляет Reka. */
[data-variant='line'] :deep([data-slot='tabs-trigger']) {
  position: relative;
  height: 100%;
  flex: none;
  border: 0;
  border-radius: 0;
  padding: 0 2px;
  background: transparent;
  color: var(--muted-foreground);
  box-shadow: none;
}

[data-variant='line'] :deep([data-slot='tabs-trigger']:hover),
[data-variant='line'] :deep([data-slot='tabs-trigger'][data-state='active']) {
  color: var(--foreground);
}

[data-variant='line'] :deep([data-slot='tabs-trigger']::after) {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: transparent;
  content: '';
}

[data-variant='line'] :deep([data-slot='tabs-trigger'][data-state='active']::after) {
  background: var(--primary);
}
</style>
